import React, { useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
// toast
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './styles/App.css';
import Login from './pages/login';
import Register from './pages/signup';
import Dashboard from './pages/dashboard';
import AddDopler from './pages/addNewDopler';
import AmazonLogin from './pages/amazonLogin';
import Settings from './pages/settings/IndexSetting';
import AdvancedSettings from './pages/settings/advancedSettings';
import DopplerInfo from './pages/settings/dopplerInfo';
import Wifi from './pages/settings/wifi';
import Brightness from './pages/settings/brightness';
import AdvancedBrightness from './pages/settings/advancedBrightness';
import DopplerColor from './pages/settings/dopplerColor';
import Audio from './pages/settings/audio';
import EditDopplerName from './pages/settings/editDopplerName';
import Weathersettings from './pages/settings/weather';
import TimezoneSettings from './pages/settings/timezone';

const App = () => {
  toast.configure();
  useEffect(() => {
    const expiresIn = localStorage.getItem('expiresIn');
    if (expiresIn) {
      const now = new Date();
      if (now.getTime() > expiresIn) {
        localStorage.clear();
        window.location.href = '/';
      }
      toast.error('Session expired! login again', {
        position: 'top-right',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });
    }
  }, []);

  return (
    <div className='App'>
      <Router>
        <Switch>
          <Route path='/amazonLogin'>
            <AmazonLogin />
          </Route>
          <Route path='/settings'>
            <Settings />
          </Route>
          <Route path='/advancedSettings'>
            <AdvancedSettings />
          </Route>
          <Route path='/dopplerInfo'>
            <DopplerInfo />
          </Route>
          <Route path='/wifi'>
            <Wifi />
          </Route>
          <Route path='/brightness'>
            <Brightness />
          </Route>
          <Route path='/advancedBrightness'>
            <AdvancedBrightness />
          </Route>
          <Route path='/dopplerColor'>
            <DopplerColor />
          </Route>
          <Route path='/audio'>
            <Audio />
          </Route>
          <Route path='/editDopplerName'>
            <EditDopplerName />
          </Route>
          <Route path='/weathersettings'>
            <Weathersettings />
          </Route>
          <Route path='/timezoneSettings'>
            <TimezoneSettings />
          </Route>
          <Route path='/addDoppler'>
            <AddDopler />
          </Route>
          <Route path='/dashboard'>
            <Dashboard />
          </Route>
          <Route path='/signup'>
            <Register />
          </Route>
          <Route path='/'>
            <Login />
          </Route>
        </Switch>
      </Router>
    </div>
  );
};

export default App;
